module.exports = __webpack_public_path__ + "img/search.0f3dce5.svg";